import { h } from 'vue'
import type { UIAlertProps } from '../../types'
import { GlobalNotificationsProseA, GlobalNotificationsButton } from '#components'
import { nativeProseComponents } from './nativeProse'

type AlertType = NonNullable<UIAlertProps['type']>

export function proseComponentsFor(color?: AlertType) {
    return {
        ...nativeProseComponents,
        a: GlobalNotificationsProseA,
        button: (_props: unknown, { attrs, slots }: { attrs: Record<string, unknown>, slots: Record<string, () => unknown> }) =>
            h(GlobalNotificationsButton, { ...attrs, ...(color ? { color } : {}) }, slots),
    }
}
